// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__38ARD","emails":"CreateEditClinics_emails__2xyNP","emailTagLabel":"CreateEditClinics_emailTagLabel__2RVgg"};